<template>
  <div>
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button class="md-primary md-simple md-dense" @click="snackbar.show = false">Dismiss</md-button>
    </md-snackbar>
    <md-dialog-alert
      :md-active.sync="alertNotification.show"
      :md-title="alertNotification.title"
      :md-content="alertNotification.message"/>
    <group-card title="Referrer Details" icon="info" padded>
      <template slot="actions">
        <md-switch v-model="pageEditable">Edit Details</md-switch>
      </template>
     <ValidationObserver v-slot="{ invalid }">
      <form class="md-layout">
        <div class="float-left">
          <md-card-content>
            <group-card icon="face" padded>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="broker-first-name">Referrer First Name</label>
                    <md-input id="broker-first-name" :disabled="!pageEditable"
                              v-model="introducerData.user.first_name" required/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="broker-last-name">Referrer Last Name</label>
                    <md-input id="broker-last-name" :disabled="!pageEditable"
                              v-model="introducerData.user.last_name"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="preferred-name">Trading Name</label>
                    <md-input id="preferred-name" :disabled="!pageEditable"
                              v-model="introducerData.trading_name"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-autocomplete
                    :md-options="administrationIntroducers"
                    v-model="introducerData.referrer_group"
                    :disabled="!pageEditable"
                  >
                    <label>Referrer Group</label>
                  </md-autocomplete>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-alignment-top-center">
                    <validated-text-input
                              label="Email"
                              v-model="introducerData.user.email"
                              melissaCheckType="email"
                              :disabled="!pageEditable"
                              @is-melissa-check-passed-changed="updateMelissaCheck"
                              required
                              ref="introducer_user_email_input"
                      />
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="contact-name">Contact Name</label>
                    <md-input id="contact-name" :disabled=true
                              v-model="introducerData.hubspot.contact_name"/>
                  </md-field>
                </div>
                <div class="md-layout-item md-alignment-top-center">
                    <validated-text-input
                              label="Contact Number"
                              ref="phone_input"
                              v-model="introducerData.contact_number"
                              :maxLength=10
                              :minLength=10
                              regex = "^\d+$"
                              errormsg="Please enter a valid phone number. The format should include only digits, and the length must be exactly ten digits."
                              melissaCheckType="phone"
                              :disabled="!pageEditable"
                              @is-melissa-check-passed-changed="updateMelissaCheck"
                      />
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="referrer-code">Referrer Code</label>
                    <md-input id="referrer-code" :disabled="!pageEditable"
                              v-model="introducerData.introducer_code"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="referral-cs-dealer-id">CS Dealer ID</label>
                    <md-input id="referral-cs-dealer-id" :disabled="!pageEditable"
                              v-model="introducerData.referral_cs_dealer_id"/>
                  </md-field>
                </div>
                <md-checkbox
                  class="md-layout-item md-size-10"
                  v-model="introducerData.referral_opted_cs"
                  :disabled="!pageEditable"
                  >
                    Opted in to CS
                </md-checkbox>
                <md-checkbox
                  class="md-layout-item md-size-10"
                  v-model="introducerData.referral_agreement"
                  :disabled="!pageEditable"
                  >
                    Referral Agreement
                </md-checkbox>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-checkbox
                    class="md-layout-item md-size-20"
                    v-model="introducerData.referral_new_lead_notification"
                    :disabled="!pageEditable"
                  >
                    Referral New Lead Notification
                  </md-checkbox>
                </div>
                <div class="md-layout-item">
                  <md-checkbox
                    class="md-layout-item md-size-20"
                    v-model="introducerData.auction_exclusion"
                    :disabled="!pageEditable"
                  >
                    Exclude from Auction
                  </md-checkbox>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="referral-comments">Comments</label>
                    <md-input id="referral-comments" :disabled="!pageEditable"
                              v-model="introducerData.referral_comments"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="referral-title">Title</label>
                    <md-input id="referral-title" :disabled="!pageEditable"
                              v-model="introducerData.referral_title"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="referral-website-url">Website URL</label>
                    <md-input id="referral-website-url" :disabled="!pageEditable"
                              v-model="introducerData.referral_website_url"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <validated-text-input
                    label="ABN"
                    :disabled="!pageEditable"
                    v-model="introducerData.referral_abn"
                    regex = "^[0-9 ]+$"
                    errormsg="Please enter a valid ABN, just spaces and digits are allowed."
                    required
                  />
                </div>
                <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-15"
                  label="Asset Type" v-model="introducerData.referral_asset_type"
                  :disabled="!pageEditable"
                  :options="options.loan_asset_type"
                  alpha_space
                />
                  <search-text-input class="md-layout-item md-size-100"
                                     label="Xero Contact ID"
                                     v-model="introducerData.xero_contact_code"
                                     :searcher="searchContactId"
                                     @select="setReferrerContactId"
                                     min-length="2"
                                     clearable
                  >
                    <template v-slot="{ item }">
                      {{ item.name }}
                    </template>
                  </search-text-input>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field md-clearable>
                    <label for="bdm-broker">BDM Broker</label>
                    <md-input id="bdm-broker" :disabled="!pageEditable"
                              v-model="brokerSearch.query" @keydown="searchBroker"/>
                  </md-field>
                </div>
                <div class="md-layout-item"> 
                  <validated-text-input
                    label="Lead Cost"
                    v-model="introducerData.lead_cost"
                    regex = "^\d+(\.\d+)?$"
                    :disabled="!pageEditable"
                    errormsg="Please enter a valid Lead Cost. The format should include only decimal."      
                  />
                </div>
              </div>
              <v-data-table
                v-if="brokerSearch.results && brokerSearch.query && brokerSearch.searching"
                :items="brokerSearch.results"
                :headers="headers"
                hide-default-header
                loading
                loading-text="Searching...."
                item-key="id"
                @click:row="handleClick"
                hide-default-footer
                class="elevation-1"
              ></v-data-table>
            </group-card>
            <group-card icon="travel_explore" title="Address" padded>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <EditApplicantAddress :value="introducerData.address"
                                        :disabled="!pageEditable"></EditApplicantAddress>
                </div>
              </div>
            </group-card>
            <group-card title="Commission Triggers" icon="settings" padded>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="broker-email">Commission Type</label>
                    <md-select v-model="introducerData.commission.trigger_type" name="commissionType"
                               id="commissionType" :disabled="!pageEditable">
                      <md-option value="percentage">Percentage</md-option>
                      <md-option value="amount">Amount</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="trigger-one-field">Trigger 1</label>
                    <md-input id="trigger-one-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.trigger_1"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="rate-one-field">Rate 1</label>
                    <md-input id="rate-one-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.rate_1"/>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="trigger-two-field">Trigger 2</label>
                    <md-input id="trigger-two-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.trigger_2"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="rate-two-field">Rate 2</label>
                    <md-input id="rate-two-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.rate_2"/>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="trigger-three-field">Trigger 3</label>
                    <md-input id="trigger-three-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.trigger_3"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="rate-three-field">Rate 3</label>
                    <md-input id="rate-three-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.rate_3"/>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="trigger-four-field">Trigger 4</label>
                    <md-input id="trigger-four-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.trigger_4"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label for="rate-four-field">Rate 4</label>
                    <md-input id="rate-four-field" :disabled="!pageEditable"
                              v-model="introducerData.commission.rate_4"/>
                  </md-field>
                </div>
              </div>
            </group-card>
            <group-card icon="account_balance" title="Bank Detail" padded>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="bank-account-name">Account Name</label>
                    <md-input id="bank-account-name" :disabled="!pageEditable"
                              v-model="introducerData.bank.account_name"/>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <validated-text-input
                    label="Account Number"
                    :disabled="!pageEditable"
                    v-model="introducerData.bank.account_number"
                    regex = "^\d+$"
                    errormsg="Please enter a valid Account Number, just digits are allowed."
                  />
                </div>
                <div class="md-layout-item">
                  <validated-text-input
                    label="BSB"
                    :disabled="!pageEditable"
                    v-model="introducerData.bank.bsb"
                    regex = "^\d+$"
                    errormsg="Please enter a valid BSB Number, just digits are allowed."
                  />
                </div>
              </div>
            </group-card>
            <group-card icon="settings" title="Webhook" padded>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="webhook">Webhook URL</label>
                    <md-input id="webhook-url" :disabled="!pageEditable"
                              v-model="introducerData.webhook_url"/>
                  </md-field>
                </div>
              </div>
            </group-card>

            <co-branding-referrer-supplier :data="introducerData"  :pageEditable="pageEditable" />

          </md-card-content>
        </div>
      </form>
      <md-card-actions>
        <span>
          <md-button class="md-raised md-primary md-fab-bottom-right"
          v-if="pageEditable"
          @click="saveIntroducer"
          :disabled="isSaving || invalid || !isMelissaCheckPassed"
          >
            <md-icon>save</md-icon>
          </md-button>
            <md-tooltip md-direction="top">Save</md-tooltip>
        </span>
      </md-card-actions>
     </ValidationObserver>
    </group-card>
  </div>
</template>
<script>
import {GroupCard} from "@/components";
import filters from "@/components/utils/filters";
import {newIntroducer} from "@/schema.js";
import {mapGetters} from "vuex";
import EditApplicantAddress from "@/components/Editors/EditApplicantAddress";
import SearchTextInput from "../components/ValidatedInput/SearchTextInput";
import ValidatedInputs from '@/components/ValidatedInput';
import CoBrandingReferrerSupplier from '@/components/CoBrandingReferrerSupplier'

export default {
  components: {
    EditApplicantAddress,
    ...ValidatedInputs,
    GroupCard,
    SearchTextInput,
    CoBrandingReferrerSupplier
  },
  data() {
    return {
      introducers: [],
      introducerData: new newIntroducer(),
      pageEditable: true,
      introducerId: this.$route.params.introducer_id,
      isSaving: false,
      isMelissaCheckPassed: false,
      snackbar: {
        show: false,
        icon: 'done',
        content: '',
      },
      alertNotification: {
        show: false,
        title: '',
        message: ''
      },
      brokerSearch: {
        query: null,
        results: null,
        searching: false
      },
      contactIdSearch: {
        query: null,
        results: null,
        searching: false
      },
      headers: [
        {text: 'id', value: 'id'},
        {text: 'Name', value: 'name'},
        {text: 'Email', value: 'email'},
      ]
    }
  },
  filters: {
    ...filters,
  },
  computed: {
    ...mapGetters([
      'options',
    ]),
    administrationIntroducers() {
      let at = this.$store.getters.administrationIntroducers();
      return at.filter(x => x.parent_id === null).map(x => ({
        id: x.id,
        name: x.full_name,
        toLowerCase: () => x.full_name.toLowerCase(),
        toString: () => x.full_name
      }));
    },
  },
  watch: {
    'brokerSearch.query'(newVal) {
      if (!newVal) {
        this.introducerData.bdm_broker.id = null;
        this.introducerData.bdm_broker.email = null;
        this.introducerData.bdm_broker.name = null;
        this.data.hubspot.broker.user_id = null;
      }
    },
    pageEditable: function (newVal) {
      if (newVal === true) {
        this.$refs.introducer_user_email_input.validate();
        this.$refs.phone_input.validate();
      }
    }
  },
  created() {
    this.getIntroducerDetails();
    this.brokerSearch.searching = false;
    this.getIntroducers();
  },
  methods: {
    async getIntroducers() {
      try {
        await this.$store.dispatch('fetch_administration_introducers', false);
      } catch (e) {
        console.error('Error when fetch introducers');
      }
    },
    async getIntroducerDetails() {
      if (this.introducerId != undefined) {
        this.pageEditable = false;
        const response = await axios.get(`/api/v1/administration/introducers/${this.introducerId}`);
        this.introducerData = response.data;
        this.brokerSearch.query = this.introducerData.bdm_broker.name;
      }
    },
    async saveIntroducer() {
      if (this.validateInputs()) {
        this.isSaving = true
        try {
          const response = await axios.post('/api/v1/administration/introducers', this.introducerData)
          if (response.status == 200) {
            this.snackbar = {
              show: true,
              icon: 'done',
              content: 'Referrer Details Saved'
            }
            this.isSaving = false
            this.pageEditable = false
          }
        } catch (e) {
          this.snackbar = {
            show: true,
            icon: 'error',
            content: 'Could not save the details.'
          }
          this.isSaving = false
          this.pageEditable = false
        }
      } else {
        this.showAlert('Missing Fields', 'Please fill all the required fields.');
      }
    },
    validateInputs() {
      if (!(this.introducerData.user.first_name && this.introducerData.user.email)) {
        return false;
      }
      return true;
    },
    updateMelissaCheck(isMelissaCheckVal) {
        this.isMelissaCheckPassed = isMelissaCheckVal;
    },
    showAlert(title, message) {
      this.alertNotification.title = title;
      this.alertNotification.message = message;
      this.alertNotification.show = true;
    },
    async searchBroker() {
      if(this.brokerSearch.query.length>2) {
        this.brokerSearch.searching = true;
        let {data: users} = await axios.get(`/api/v1/administration/role_based_users/${this.brokerSearch.query}/broker`);
        this.brokerSearch.results = users;
        this.brokerSearch.searching = true;
      }
    },
    handleClick(broker) {
      this.introducerData.bdm_broker.id = broker.id;
      this.introducerData.bdm_broker.email = broker.email;
      this.introducerData.bdm_broker.name = broker.name;
      this.brokerSearch.query = broker.name;
      this.brokerSearch.results = null;
    },
    async searchContactId(query) {
      this.contactIdSearch.searching = true;
      let {data} = await this.$store.dispatch('get_xero_contacts', query);
      return data;
    },
    setReferrerContactId(contact){
      this.introducerData.xero_contact_code = contact.contact_id;
    }
  },
  async beforeCreate() {
    const params = {
      types: [
        'loan_asset_type',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>
